export default function numToPrice(num = 0) {
  return num?.toLocaleString('fr-FR')
}
